import React from 'react'
import { reduxForm } from 'redux-form'

import FormField, { FormLayout } from 'shared/newFormElements'

import Window from '../Window'

const PlayGround = () => (
  <Window id="playground" name="play-ground" uri="/secure/play-ground" icon="user">
    <FormLayout label="playground-input">
      <FormField type="input" name="playground-input" />
    </FormLayout>
  </Window>
)

export default reduxForm({
  form: 'play-ground',
  validate: (fields) => {
    const errors = {}

    if (!fields['playground-input']) {
      errors['playground-input'] = 'field is required'
    }

    return errors
  },
})(PlayGround)
